export type IMedicalEmergencyApiResponse = {
  id: number;
  passengerId: number;
  passengerName: string;
  flightId: string;
  symptoms: string;
  notes: string | null;
  status: MedicalEmergencyStatus;
  ageGroup: null;
  treatmentsGiven: string[];
  passengerStatusQuestions: PassengerStatusQuestion[];
  timestamp: string;
  createdBy: string;
  assignedEms: string;
  seatNumber: null | string;
  notificationShow: string,
  diversionDecisionStatus: string
  flightPrimaryKey:string;
  isPatientConscious: boolean;
  assesment: string;
  objective: string;
  subjective: string;
  plain: string;
};

export interface PassengerStatusQuestion {
  question: string;
  response: string;
}

export enum MedicalEmergencyStatus {
  NOTIFIED = "NOTIFIED",
  MONITORING = "MONITORING",
  RESOLVED = "RESOLVED",
  EMERGENCY_CARE_REQUIRED = "EMERGENCY_CARE_REQUIRED",
  CONTINUE_AND_MONITOR = "CONTINUE_AND_MONITOR"
}
